<template>
  <v-container>
    <v-sheet>
      <EntrySubmissionComponent
        :year="props.year"
        :is-preview="true"
        @close="emit('close')"></EntrySubmissionComponent>
    </v-sheet>
  </v-container>
</template>
<script setup lang="ts">
import EntrySubmissionComponent from '@/components/entry/EntrySubmissionComponent.vue';
import { IYearDTO } from '@/dtos';
const emit = defineEmits(['close']);
const props = defineProps<{ year: IYearDTO }>();
</script>
